<form
  class="behavior-code-reaction"
  [formGroup]="behaviorCodeReactionForm"
  novalidate>
  <mat-card appearance="outlined" class="behavior-code-reaction-form mat-elevation-z3">
    <mat-card-header class="behavior-code-reaction-form-header card-header">
      <mat-card-title *ngIf="isCreating">
        <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
        Add Reaction to Behavior Code
      </mat-card-title>
      <mat-card-title *ngIf="!isCreating">
        <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
        Edit Reaction for Behavior Code
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="behavior-code-reaction-form-content">
      <div class="form-row">
      <app-autocomplete
        label="Reaction"
        placeholder="Reaction"
        (selectionChange)="setReaction($event)"
        [options]="reactionOptions"
        [(inputDisplay)] = "selectedReaction"
      />
      </div>
      <div *ngIf="(isDefault | async) && (showToastMessage | async)" class="toast-info">
        <div>
          The Default Reaction is assigned whenever a reaction is not explicitly
        defined for a given "Assign At" count.
        </div>
        <fa-icon class="toast-info-close" (click)="onCloseToast()" [icon]="['fas', 'close']"></fa-icon>
      </div>
      <div class="form-row">
        <mat-radio-group class="full-width-input" formControlName="reactionType">
        
          <mat-radio-button 
            [matTooltipDisabled]="isDefault.getValue()"
            matTooltip="A default reaction already exists. Edit it to make changes."
            matTooltipPosition="right"
            matTooltipClass="radial-tooltip"
            [disabled]="isCreating || !isDefault.getValue()" value="default" (change)="updateReactionType(selectetedReactionTypeEnum.DEFAULT)">
            <p>
              <b>Default:</b>&nbsp;Make this the default reaction
            </p>
          </mat-radio-button>
       
          <mat-radio-button 
            [matTooltipDisabled]="isDefault.getValue()"
            matTooltip="When selected, reactions that aren’t applicable will be hidden."
            matTooltipPosition="right"
            matTooltipClass="radial-tooltip"
            [disabled]="isDefault.getValue()"  value="assignAt" (change)="updateReactionType(selectetedReactionTypeEnum.ASSIGN_AT)">
            <p><b>Assign At:</b>&nbsp;This reaction will occur after a specific amount of tracks</p>
          </mat-radio-button>
    
       
          <mat-radio-button 
            [matTooltipDisabled]="isDefault.getValue()"
            matTooltip="When selected, reactions that aren’t applicable will be hidden."
            matTooltipPosition="right"
            matTooltipClass="radial-tooltip"
            [disabled]="isDefault.getValue()"  value="selectMenu" (change)="updateReactionType(selectetedReactionTypeEnum.SELECT_MENU)">
            <p><b>Select From Menu:</b>&nbsp;This reaction will be inside a menu and can be assign at any amount of tracks</p>
          </mat-radio-button>

        </mat-radio-group>
      </div>
      <div class="form-row" *ngIf="displayTriggerCount | async">
        <mat-form-field class="full-width-input">
          <mat-label>Assign At: Should happen after X entries</mat-label>
          <input matInput formControlName="triggerCount" type="number" />
          <app-error-display
            [form]="behaviorCodeReactionForm"
            controlName="triggerCount"></app-error-display>
        </mat-form-field>
        <small class="help-text">
          This action will occur after a student is tracked this amount of times.
        </small>
      </div>
      <div class="form-row">
        <mat-form-field class="full-width-input">
          <mat-label>Remove or add points</mat-label>
          <input matInput formControlName="points" type="number" />
          <app-error-display
            [form]="behaviorCodeReactionForm"
            controlName="points"></app-error-display>
        </mat-form-field>
        <small class="help-text">
          This action will add or remove the selected amount of points from a
          tracked student. Use negative numbers for removing points.
        </small>
      </div>

      <div class="form-row">
        <mat-form-field class="full-width-input">
          <mat-label>Repeat action X times when rule met</mat-label>
          <input matInput formControlName="reactionMultiplier" type="number" />
          <app-error-display
            [form]="behaviorCodeReactionForm"
            controlName="reactionMultiplier"></app-error-display>
        </mat-form-field>
        <small class="help-text">
          This will multiply the action by the number selected. For example, if
          you select 2 for a detention, the student will be given 2 detentions.
          This should not be changed in most cases.
        </small>
      </div>

      <div class="form-row">
        <mat-form-field class="full-width-input">
          <mat-label>Print X copies of each pass</mat-label>
          <input matInput formControlName="printCopies" type="number" />
          <app-error-display
            [form]="behaviorCodeReactionForm"
            controlName="printCopies"></app-error-display>
        </mat-form-field>
        <small class="help-text">
          This will determine how many passes are printed by default when this
          action is used.
        </small>
      </div>
    </mat-card-content>
  </mat-card>
</form>
